export const API_PREFIX = '/api/v1';
export const EMPLOYEE_ENDPOINTS = {
    LIST: `${API_PREFIX}/employees`,
    DETAIL: (id) => `${API_PREFIX}/employees/${id}`,
    CREATE: `${API_PREFIX}/employees`,
    EXPORT: `${API_PREFIX}/employees/export`,
    ORG_TREE: `${API_PREFIX}/employees/org-tree`,
    SUBORDINATES: (id) => `${API_PREFIX}/employees/${id}/subordinates`,
    SUPERVISOR_CHAIN: (id) => `${API_PREFIX}/employees/${id}/supervisor-chain`,
    RESTORE: (id) => `${API_PREFIX}/employees/${id}/restore`,
    HARD_DELETE: (id) => `${API_PREFIX}/employees/${id}/hard`,
    COMPETENCIES: (id) => `${API_PREFIX}/employees/${id}/competencies`,
    WORKING_TIME: (id) => `${API_PREFIX}/employees/${id}/working-time`,
    FLEXTIME_ACCOUNT: (id) => `${API_PREFIX}/employees/${id}/flextime/account`,
    FLEXTIME_ENTRIES: (id) => `${API_PREFIX}/employees/${id}/flextime/entries`,
    TENANT_ASSIGNMENTS: (id) => `${API_PREFIX}/employees/${id}/tenant-assignments`,
    CONTRACT: (id) => `${API_PREFIX}/employees/${id}/contract`,
    CONTRACT_DETAIL: (id, cid) => `${API_PREFIX}/employees/${id}/contract/${cid}`,
    CONTRACT_HISTORY: (id) => `${API_PREFIX}/employees/${id}/contract/history`,
    TIME_ACCOUNTS: (id) => `${API_PREFIX}/employees/${id}/time-accounts`,
    TIME_ACCOUNT_DETAIL: (id, aid) => `${API_PREFIX}/employees/${id}/time-accounts/${aid}`,
    TIME_ACCOUNT_ENTRIES: (id, aid) => `${API_PREFIX}/employees/${id}/time-accounts/${aid}/entries`,
    TIME_ACCOUNT_CLOSE: (id, aid) => `${API_PREFIX}/employees/${id}/time-accounts/${aid}/close-period`,
    SPECIAL_LEAVE: (id) => `${API_PREFIX}/employees/${id}/special-leave`,
    SPECIAL_LEAVE_DETAIL: (id, sid) => `${API_PREFIX}/employees/${id}/special-leave/${sid}`,
    WORKING_TIME_HISTORY: (id) => `${API_PREFIX}/employees/${id}/working-time/history`,
};
export const COMPETENCY_ENDPOINTS = {
    LIST: `${API_PREFIX}/competencies`,
    DETAIL: (id) => `${API_PREFIX}/competencies/${id}`,
};
export const WORKING_TIME_ENDPOINTS = {
    PROFILES: `${API_PREFIX}/working-time-profiles`,
    PROFILE_DETAIL: (id) => `${API_PREFIX}/working-time-profiles/${id}`,
    PROFILE_DUPLICATE: (id) => `${API_PREFIX}/working-time-profiles/${id}/duplicate`,
};
export const COMPLIANCE_ENDPOINTS = {
    CHECK: (employeeId) => `${API_PREFIX}/compliance/check/${employeeId}`,
    REPORT: `${API_PREFIX}/compliance/report`,
    VIOLATIONS: `${API_PREFIX}/compliance/violations`,
};
export const CORPORATION_ENDPOINTS = {
    LIST: `${API_PREFIX}/corporations`,
    DETAIL: (id) => `${API_PREFIX}/corporations/${id}`,
};
export const OU_ENDPOINTS = {
    LIST: `${API_PREFIX}/ous`,
    DETAIL: (id) => `${API_PREFIX}/ous/${id}`,
};
export const LOCATION_ENDPOINTS = {
    LIST: `${API_PREFIX}/locations`,
    DETAIL: (id) => `${API_PREFIX}/locations/${id}`,
};
export const CONTACT_ENDPOINTS = {
    LIST: `${API_PREFIX}/contacts`,
    DETAIL: (id) => `${API_PREFIX}/contacts/${id}`,
};
export const SURCHARGE_ENDPOINTS = {
    DEFINITIONS: `${API_PREFIX}/surcharges`,
    DEFINITION_DETAIL: (id) => `${API_PREFIX}/surcharges/${id}`,
    ASSIGNMENTS: `${API_PREFIX}/surcharges/assignments`,
};
export const HOLIDAY_ENDPOINTS = {
    COUNTRIES: `${API_PREFIX}/holidays/countries`,
    PROFILES: `${API_PREFIX}/holidays/profiles`,
    PROFILE_DETAIL: (id) => `${API_PREFIX}/holidays/profiles/${id}`,
    GENERATE: (id) => `${API_PREFIX}/holidays/profiles/${id}/generate`,
    ENTRIES: `${API_PREFIX}/holidays/entries`,
    SYNC_STATUS: `${API_PREFIX}/holidays/sync/status`,
    SYNC_TRIGGER: `${API_PREFIX}/holidays/sync`,
};
export const RESOURCE_ENDPOINTS = {
    CATEGORIES: `${API_PREFIX}/resources/categories`,
    CATEGORY_DETAIL: (id) => `${API_PREFIX}/resources/categories/${id}`,
    LIST: `${API_PREFIX}/resources`,
    DETAIL: (id) => `${API_PREFIX}/resources/${id}`,
    AVAILABILITY: (id) => `${API_PREFIX}/resources/${id}/availability`,
};
export const BOOKING_ENDPOINTS = {
    LIST: `${API_PREFIX}/bookings`,
    DETAIL: (id) => `${API_PREFIX}/bookings/${id}`,
    APPROVE: (id) => `${API_PREFIX}/bookings/${id}/approve`,
    RULES: `${API_PREFIX}/bookings/rules/list`,
    RULE_CREATE: `${API_PREFIX}/bookings/rules`,
    RULE_DETAIL: (id) => `${API_PREFIX}/bookings/rules/${id}`,
};
export const ABSENCE_ENDPOINTS = {
    LIST: `${API_PREFIX}/absences`,
    DETAIL: (id) => `${API_PREFIX}/absences/${id}`,
    SUBMIT: (id) => `${API_PREFIX}/absences/${id}/submit`,
    CANCEL: (id) => `${API_PREFIX}/absences/${id}/cancel`,
    APPROVE: (id) => `${API_PREFIX}/absences/${id}/approve`,
    TYPES: `${API_PREFIX}/absences/types`,
    TYPE_DETAIL: (id) => `${API_PREFIX}/absences/types/${id}`,
    QUOTAS_ME: `${API_PREFIX}/absences/quotas/me`,
    QUOTAS_USER: (userId) => `${API_PREFIX}/absences/quotas/${userId}`,
};
export const ATTENDANCE_ENDPOINTS = {
    LIST: `${API_PREFIX}/attendance`,
    DETAIL: (id) => `${API_PREFIX}/attendance/${id}`,
    TYPES: `${API_PREFIX}/attendance/types`,
    TYPE_DETAIL: (id) => `${API_PREFIX}/attendance/types/${id}`,
};
export const CALENDAR_ENDPOINTS = {
    TEAM: `${API_PREFIX}/calendar/team`,
    APPOINTMENTS: `${API_PREFIX}/calendar/appointments`,
    APPOINTMENT_DETAIL: (id) => `${API_PREFIX}/calendar/appointments/${id}`,
    APPOINTMENT_CHECK: `${API_PREFIX}/calendar/appointments/check`,
    EVENTS: `${API_PREFIX}/calendar/events`,
};
export const PRIVACY_ENDPOINTS = {
    CONFIG: `${API_PREFIX}/privacy/config`,
    OVERRIDES: `${API_PREFIX}/privacy/overrides`,
    OVERRIDE_DETAIL: (id) => `${API_PREFIX}/privacy/overrides/${id}`,
    AUDIT_LOG: `${API_PREFIX}/privacy/audit-log`,
    AUDIT_VERIFY: `${API_PREFIX}/privacy/audit-log/verify`,
};
export const NOTIFICATION_ENDPOINTS = {
    LIST: `${API_PREFIX}/notifications`,
    DETAIL: (id) => `${API_PREFIX}/notifications/${id}`,
    MARK_READ: (id) => `${API_PREFIX}/notifications/${id}/read`,
};
export const PREFERENCE_ENDPOINTS = {
    LIST: `${API_PREFIX}/preferences`,
    DETAIL: (key) => `${API_PREFIX}/preferences/${key}`,
};
export const DASHBOARD_ENDPOINTS = {
    DATA: `${API_PREFIX}/dashboard`,
    METRICS: `${API_PREFIX}/dashboard/metrics`,
    ME: `${API_PREFIX}/dashboard/me`,
    TEAM: `${API_PREFIX}/dashboard/team`,
    GLOBAL: `${API_PREFIX}/dashboard/global`,
    PRESETS: `${API_PREFIX}/dashboard/presets`,
    PRESET_DETAIL: (id) => `${API_PREFIX}/dashboard/presets/${id}`,
    PRESET_SHARE: (id) => `${API_PREFIX}/dashboard/presets/${id}/share`,
    PREFERENCES: `${API_PREFIX}/dashboard/preferences`,
};
export const REPORT_ENDPOINTS = {
    TEMPLATES: `${API_PREFIX}/reports/templates`,
    TEMPLATE_DETAIL: (id) => `${API_PREFIX}/reports/templates/${id}`,
    EXECUTE: `${API_PREFIX}/reports/execute`,
    EXPORT: `${API_PREFIX}/reports/export`,
    WORK_TIME: `${API_PREFIX}/reports/work-time`,
    OVERTIME: `${API_PREFIX}/reports/overtime`,
    LEAVE_BALANCE: `${API_PREFIX}/reports/leave-balance`,
    TICKET_COSTS: `${API_PREFIX}/reports/ticket-costs`,
    EMPLOYEES: `${API_PREFIX}/reports/employees`,
    PROJECTS: `${API_PREFIX}/reports/projects`,
};
export const BC_EXPORT_ENDPOINTS = {
    LIST: `${API_PREFIX}/bc-exports`,
    DETAIL: (id) => `${API_PREFIX}/bc-exports/${id}`,
    LINES: (id) => `${API_PREFIX}/bc-exports/${id}/lines`,
    SEND: (id) => `${API_PREFIX}/bc-exports/${id}/send`,
    CANCEL: (id) => `${API_PREFIX}/bc-exports/${id}/cancel`,
    RETRY: (id) => `${API_PREFIX}/bc-exports/${id}/retry`,
    SYNC_STATUS: `${API_PREFIX}/bc-exports/sync/status`,
    SYNC_TRIGGER: `${API_PREFIX}/bc-exports/sync/trigger`,
    CONFIG: `${API_PREFIX}/bc-exports/config`,
};
export const TICKET_ENDPOINTS = {
    LIST: `${API_PREFIX}/tickets`,
    DETAIL: (id) => `${API_PREFIX}/tickets/${id}`,
    SEARCH: `${API_PREFIX}/tickets/search`,
    ASSIGN: (id) => `${API_PREFIX}/tickets/${id}/assign`,
    TRANSITION: (id) => `${API_PREFIX}/tickets/${id}/transition`,
    HISTORY: (id) => `${API_PREFIX}/tickets/${id}/history`,
    COMMENTS: (id) => `${API_PREFIX}/tickets/${id}/comments`,
    COMMENT_DETAIL: (id, cid) => `${API_PREFIX}/tickets/${id}/comments/${cid}`,
    ATTACHMENTS: (id) => `${API_PREFIX}/tickets/${id}/attachments`,
    ATTACHMENT_DETAIL: (id, aid) => `${API_PREFIX}/tickets/${id}/attachments/${aid}`,
    CATEGORIES: `${API_PREFIX}/ticket-categories`,
    CATEGORY_DETAIL: (id) => `${API_PREFIX}/ticket-categories/${id}`,
    STATS_SUMMARY: `${API_PREFIX}/ticket-stats/summary`,
    STATS_BY_STATUS: `${API_PREFIX}/ticket-stats/by-status`,
    STATS_BY_CATEGORY: `${API_PREFIX}/ticket-stats/by-category`,
    STATS_BY_ASSIGNEE: `${API_PREFIX}/ticket-stats/by-assignee`,
    STATS_SLA: `${API_PREFIX}/ticket-stats/sla-compliance`,
    STATS_TIMELINE: `${API_PREFIX}/ticket-stats/timeline`,
};
export const DUTY_ROSTER_ENDPOINTS = {
    SHIFT_TEMPLATES: `${API_PREFIX}/duty-roster/shift-templates`,
    SHIFT_TEMPLATE_DETAIL: (id) => `${API_PREFIX}/duty-roster/shift-templates/${id}`,
    INDUSTRY_PRESETS: `${API_PREFIX}/duty-roster/industry-presets`,
    INDUSTRY_PRESET_APPLY: (code) => `${API_PREFIX}/duty-roster/industry-presets/${code}/apply`,
    ROSTER_PLANS: `${API_PREFIX}/duty-roster/plans`,
    ROSTER_PLAN_DETAIL: (id) => `${API_PREFIX}/duty-roster/plans/${id}`,
    ROSTER_PLAN_PUBLISH: (id) => `${API_PREFIX}/duty-roster/plans/${id}/publish`,
    ROSTER_PLAN_APPROVE: (id) => `${API_PREFIX}/duty-roster/plans/${id}/approve`,
    ROSTER_ENTRIES: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/entries`,
    ROSTER_ENTRY_DETAIL: (planId, entryId) => `${API_PREFIX}/duty-roster/plans/${planId}/entries/${entryId}`,
    ROSTER_ENTRIES_BULK: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/entries/bulk`,
    EMPLOYEE_PREFERENCES: (employeeId) => `${API_PREFIX}/duty-roster/employees/${employeeId}/preferences`,
    SWAP_REQUESTS: `${API_PREFIX}/duty-roster/swap-requests`,
    SWAP_REQUEST_ACCEPT: (id) => `${API_PREFIX}/duty-roster/swap-requests/${id}/accept`,
    SWAP_REQUEST_REJECT: (id) => `${API_PREFIX}/duty-roster/swap-requests/${id}/reject`,
    COVERAGE_RULES: (ouId) => `${API_PREFIX}/duty-roster/coverage-rules/${ouId}`,
    VALIDATE: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/validate`,
    SUGGESTIONS: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/suggestions`,
    REPORT_COVERAGE: (planId) => `${API_PREFIX}/duty-roster/reports/${planId}/coverage`,
    REPORT_FAIRNESS: (planId) => `${API_PREFIX}/duty-roster/reports/${planId}/fairness`,
    REPORT_OVERTIME: (planId) => `${API_PREFIX}/duty-roster/reports/${planId}/overtime`,
    // Cycle Management
    PLAN_CYCLES: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/cycles`,
    CYCLE_DETAIL: (id) => `${API_PREFIX}/duty-roster/cycles/${id}`,
    CYCLE_DUPLICATE: (id) => `${API_PREFIX}/duty-roster/cycles/${id}/duplicate`,
    CYCLE_DAYS: (cycleId) => `${API_PREFIX}/duty-roster/cycles/${cycleId}/days`,
    CYCLE_DAY_DETAIL: (dayId) => `${API_PREFIX}/duty-roster/cycle-days/${dayId}`,
    CYCLE_DAY_TASKS: (dayId) => `${API_PREFIX}/duty-roster/cycle-days/${dayId}/tasks`,
    CYCLE_TASK_DETAIL: (taskId) => `${API_PREFIX}/duty-roster/cycle-tasks/${taskId}`,
    // Time Controlling
    TIME_CONTROLLING: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/time-controlling`,
    OVERTIME_WARNINGS: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/overtime-warnings`,
    WORK_LOGS: (planId) => `${API_PREFIX}/duty-roster/plans/${planId}/worklogs`,
};
export const CMDB_ENDPOINTS = {
    OBJECT_TYPES: `${API_PREFIX}/cmdb/object-types`,
    OBJECT_TYPE_DETAIL: (id) => `${API_PREFIX}/cmdb/object-types/${id}`,
    OBJECT_TYPE_TREE: `${API_PREFIX}/cmdb/object-types?tree=true`,
    OBJECT_TYPE_CHILDREN: (id) => `${API_PREFIX}/cmdb/object-types/${id}/children`,
    OBJECT_TYPE_ATTRIBUTES: (id) => `${API_PREFIX}/cmdb/object-types/${id}/attributes`,
    OBJECT_TYPE_FORM: (id) => `${API_PREFIX}/cmdb/object-types/${id}/form`,
    ATTRIBUTES: `${API_PREFIX}/cmdb/attributes`,
    ATTRIBUTE_DETAIL: (id) => `${API_PREFIX}/cmdb/attributes/${id}`,
    ATTRIBUTE_ASSIGN: (id) => `${API_PREFIX}/cmdb/attributes/${id}/assign`,
    ATTRIBUTE_UNASSIGN: (id, otId) => `${API_PREFIX}/cmdb/attributes/${id}/unassign/${otId}`,
    ITEMS: `${API_PREFIX}/cmdb/items`,
    ITEM_DETAIL: (id) => `${API_PREFIX}/cmdb/items/${id}`,
    OT_OPTIONS: `${API_PREFIX}/cmdb/ot-options`,
    OT_OPTION_DETAIL: (id) => `${API_PREFIX}/cmdb/ot-options/${id}`,
    STATS: `${API_PREFIX}/cmdb/stats`,
};
//# sourceMappingURL=api-endpoints.js.map